import {Component, OnInit} from '@angular/core';
import {TableReactiveUrlController} from '@amlCore/tableReactive';
import {DictionaryService, TableService, UserService, VisitedService} from '@amlCore/services';
import {ActivatedRoute, Router} from '@angular/router';
import {AccessJson} from '@amlCore/models';
import {CountryRiskService} from "./countryRisk.service";
import {RiskAccessEnum} from "../../../core/enum/riskAccessEnum";
import {CountryRiskModel} from "../../model/countryRisk.model";
import {CountryItemModel} from "../../../client";

@Component({
  moduleId: "6666",
  selector: 'app-countryrisk-list',
  templateUrl: './countryRiskList.component.html'
})
export class CountryRiskListComponent extends TableReactiveUrlController implements OnInit {
  params: any;
  isShowVisited = true;
  protected countryRiskList: CountryRiskModel[] = [];
  access: AccessJson;

  constructor(protected readonly activatedRoute: ActivatedRoute,
              protected readonly visitedService: VisitedService,
              protected readonly tableService: TableService,
              protected readonly router: Router,
              protected readonly bankServiceService: CountryRiskService,
              private readonly usersService: UserService,
              protected dictSrv: DictionaryService) {
    super(router, activatedRoute, visitedService, tableService, {});
  }

  ngOnInit(): void {
    this.access = this.usersService.getAccess(RiskAccessEnum.RISK_COUNTRIES);
    this.activatedRoute.queryParams.subscribe((data) => {
      this.loadList(data);
    });
  }

  loadList(params?: any): void {
    this.bankServiceService.getList(params).subscribe(data => {
      this.countryRiskList = data;
      this.total = data.length;
      this.scrollRun();
    });
  }

  open(data: CountryRiskModel): void {
    this.tableService.saveScrollPosition(this.commonKeyStore);
    this.router.navigate([`/registries/countryRisks/${data.id}`]);
    this.saveRowId(data.id);
  }

  public getFilterObject(filter: any) {
    return filter;
  }

  onPageChange(params: any): void {
  }
}
